import request from '../utils/request'


export function index(params) {
    return request({
        url: '/couriers',
        method: 'get',
        params
    })
}


export function inventory(params) {
    return request({
        url: '/couriers/inventory',
        method: 'get',
        params
    })
}

export function getLastId(params) {
    return request({
        url: '/couriers/getLastId',
        method: 'get',
        params
    })
}
export function show(id) {
    return request({
        url: `/couriers/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: '/couriers',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `/couriers/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `/couriers/${id}`,
        method: 'delete',
    })
}